import React from "react";
import "./Banner.css";
import { useLocation } from "react-router-dom";
import CustomButton from "../../components/UI/CustomButton";

// CLEAN FUNCTION - used for folder names
const clean = (txt) => txt.toLowerCase().replace(/[^a-z0-9]+/g, "");

// CLEAN FULL PATH INTO A UNIQUE KEY
const cleanFullPath = (pathname) => {
  const parts = pathname.split("/").filter(Boolean);
  return parts.map(clean).join("_");
};

// ==========================================================
// MASTER BANNER CONFIG — ENGLISH
// ==========================================================
const bannerConfigEN = {
  about: {
    image: "/assets/images/about-banner.jpg",
    showBgTitle: true,
    bgTitle: "ABOUT US",
    title: `SETTING NEW STANDARDS IN FINANCIAL INTELLIGENCE & ADVISORY`,
    subtitle:
      "Our team blends proven financial expertise with real-world understanding to help organizations grow, optimize, and stay resilient.",
    buttonText: null,
  },
  careers: {
    image: "/assets/images/about-banner.jpg",
    showBgTitle: true,
    bgTitle: "Career",
    title: `Join Our Team of Financial Experts`,
    subtitle:
      "Shape your career with a firm that values growth, innovation, and excellence. Build your future with industry-leading professionals.",
    buttonText: null,
  },
  blog: {
    image: "/assets/images/about-banner.jpg",
    showBgTitle: true,
    bgTitle: "Blog",
    title: `Insights & Articles`,
    subtitle: "Expert Perspectives on Accounting, Finance, and Business Growth",
    buttonText: null,
  },
  contact: {
    image: "/assets/images/about-banner.jpg",
    showBgTitle: true,
    bgTitle: "Get in Touch",
    title: `contact us if you have any questions`,
    subtitle: "",
    buttonText: null,
  },
  services_auditandassurance_financialstatementaudit: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `FINANCIAL INTEGRITY DELIVERED WITH EXPERTISE`,
    subtitle:
      "Businesses face compliance pressure and investors demand transparent reporting. Our audits verify every number, reduce risks, and build confidence.",
    buttonText: "Explore Audit Services",
  },
  services_auditandassurance_ifrsadvisoryservice: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `IFRS ADVISORY FOR MODERN FINANCE`,
    subtitle:
      "Achieve smooth reporting transitions with experts who translate complex IFRS standards into clear, compliant, and decision-ready financial statements.",
    buttonText: "Talk to Experts",
  },
  services_auditandassurance_internalcontrolframework: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `INTERNAL CONTROLS THAT STRENGTHEN EVERY DECISION`,
    subtitle:
      "Internal controls fail silently until risk becomes visible. We build frameworks that prevent breakdowns before they cost you.",
    buttonText: "Begin Your Assessment",
  },
  services_auditandassurance_otherassuranceservice: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `ASSURANCE THAT SEES BEYOND NUMBERS`,
    subtitle:
      "Assurance isn't paperwork, it's leverage. Use verified information to improve standing with investors, regulators, and partners.",
    buttonText: "Explore Assurance Services",
  },
  services_advisory_dealadvisory: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `DECISIONS THAT TURN DEALS INTO WINS`,
    subtitle:
      "We guide businesses through mergers, acquisitions, divestments, and capital transactions with clarity, foresight, and data-grounded intelligence.",
    buttonText: "Talk to Deal Experts",
  },
  services_advisory_restructuring: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `WHEN BUSINESSES NEED A SECOND BEGINNING`,
    subtitle:
      "Cash pressures, fragmented operations, and market shifts can push a business off-track. We help organizations realign, recover, and return stronger.",
    buttonText: "More About Advisory",
  },
  services_advisory_duediligence: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `INTELLIGENT DUE DILIGENCE FOR SMARTER INVESTMENTS`,
    subtitle:
      "No missed signals. No hidden risks. Just transparent due diligence that drives confident growth.",
    buttonText: "Explore Due Diligence",
  },
  services_advisory_forensicservices: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `YOUR FIRST DEFENSE AGAINST FRAUD & MISCONDUCT`,
    subtitle:
      "Evidence-backed reports, litigation-ready documentation, fraud risk audits & forensic analytics built for corporate assurance.",
    buttonText: "Request Forensic Support",
  },
  services_advisory_riskadvisory: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `SEE THE RISK BEFORE IT HITS`,
    subtitle:
      "Markets change. Regulations tighten. Systems fail. Risks emerge silently unless monitored with intelligence and acted on with clarity. What's next?",
    buttonText: "Build Risk Strategy!",
  },
  services_advisory_technologyadvisoryservice: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `TECHNOLOGY THAT CUTS NOISE, DRIVES VALUE`,
    subtitle:
      "Digital transformation shouldn't feel complex or expensive. So, we help companies choose technology that improves speed, security, and profitability, not just infrastructure.",
    buttonText: "Talk to Advisor",
  },
  services_advisory_valuations: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `WHEN PRICE MEETS PROOF, DEALS STRENGTHEN`,
    subtitle:
      "Gain sharper clarity on business worth through analytical valuation backed by benchmarks, forecasts, and evidence.",
    buttonText: "Speak to Expert",
  },
  services_taxation_corporatetax: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "PRECISION TAX ADVISORY FOR SMART BUSINESSES",
    subtitle:
      "Businesses partnering with us reduce tax exposure, strengthen reporting, and uncover saving opportunities hidden in legislation.",
    buttonText: "Talk to Strategist",
  },
  services_taxation_mergerandacquisition: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "STRUCTURING TRANSACTIONS, REDUCING TAX STRESS",
    subtitle:
      "M&A succeeds only when the tax foundation is risk-free and financially strategic. We ensure every transaction is structured for savings and long-term value creation.",
    buttonText: "Explore M&A Advisory",
  },
  services_taxation_transferpricing: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "DON'T LET COMPLIANCE EAT YOUR PROFITS",
    subtitle:
      "We create pricing frameworks that satisfy authorities while protecting margins. A balance between tax efficiency and regulatory defensibility.",
    buttonText: "Work With Experts",
  },
  services_taxation_valueaddedtax: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "COMPLIANCE TODAY, TAX CERTAINTY TOMORROW",
    subtitle:
      "VAT isn't just filing returns! Hence, we help businesses stay compliant, reduce exposure, and make tax outcomes predictable across their operations.",
    buttonText: "Talk to VAT Specialists",
  },
  services_taxation_internationaltax: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "STRATEGIC TAX INTELLIGENCE ACROSS BORDERS",
    subtitle:
      "Expand globally without stumbling over tax barriers. We help you navigate international regulations, optimize cross-border taxation, and unlock opportunities with compliance.",
    buttonText: "Get Expert Guidance",
  },
  services_taxation_excisetax: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "COMPLIANCE THAT PROTECTS PROFIT WITHOUT GUESSWORK",
    subtitle:
      "Excise tax laws shift fast — one missed update can cost a business heavily. Our team ensures you classify, calculate, and comply with absolute accuracy.",
    buttonText: "Speak to Advisor",
  },
  services_taxation_taxrestructuring: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "TAX RESTRUCTURING THAT PAYS BACK",
    subtitle:
      "Tax restructuring isn't about cutting costs. We redesign your taxation structure so your company saves more, functions cleaner, and expands stronger.",
    buttonText: "Talk to Experts",
  },
  services_taxation_economicsubstanceregulations: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "CONFIDENT ESR REPORTING WITHOUT COMPLEXITY",
    subtitle:
      "Economic Substance Regulations demand proof of genuine management, decision-making and commercial presence. We help you assess, document and demonstrate it.",
    buttonText: "Ensure ESR Compliance",
  },
  services_businessserviceoutsourcing_financeandaccounting: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "FINANCIAL CLARITY BECOMES YOUR ADVANTAGE",
    subtitle:
      "Efficient finance doesn't just bookkeep; it also drives strategy, stability, and scalability. And the good news is – we take charge of your accounting lifecycle.",
    buttonText: "Get Finance Support",
  },
  services_businessserviceoutsourcing_corporateadvisoryservices: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "CLARITY BEFORE EVERY MAJOR BUSINESS MOVE",
    subtitle:
      "Growth isn't luck — it's structured, informed, and strategically navigated. We help organizations make high-value decisions backed by insight, not intuition.",
    buttonText: "Get Advisory Support",
  },
  services_businessserviceoutsourcing_expensesclaimmanagement: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "A SMARTER WAY TO TRACK, VERIFY, AND REIMBURSE",
    subtitle:
      "Gain transparent audit trails, 2× faster verification cycles, policy-aligned submissions, and real-time spending insights.",
    buttonText: "Get Started",
  },
  services_businessserviceoutsourcing_payrollhrservices: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "EMPOWERING TEAMS THROUGH ACCURATE PAYROLL",
    subtitle:
      "Managing people is complex, but your payroll and HR operations don't have to be. Our streamlined, compliant, and fully managed solutions ensure every process runs accurately, securely, and on time.",
    buttonText: "Explore Payroll Services",
  },
  services_businessserviceoutsourcing_secondment: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "AGILE TALENT FOR MODERN TEAMS",
    subtitle:
      "Facing workload spikes or sudden skill gaps? Our experts join your team instantly, follow your internal processes, and keep business running smoothly.",
    buttonText: "Request Secondment Support",
  },
  services_businessserviceoutsourcing_treasuryservice: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "TREASURY BUILT FOR TODAY'S RISKS",
    subtitle:
      "Treasury management is no longer about processing payments — it's about safeguarding liquidity, mitigating risk, and enabling decision-making.",
    buttonText: "Explore Treasury Services",
  },
  services_strategies_marketresearch: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "RESEARCH THAT REDUCES YOUR MARKET RISKS",
    subtitle:
      "Winning markets isn't about assumptions; it's about clarity. Our research turns behaviour, demand shifts, and industry signals into a strategic direction you can trust.",
    buttonText: "Explore Market Research",
  },
  services_strategies_businessconsulting: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "TURNING BUSINESS COMPLEXITY INTO COMPETITIVE ADVANTAGE",
    subtitle:
      "Business challenges rarely sit in silos, and neither do our solutions. Pestel & Partners delivers advisory support that helps leaders rethink operations & unlock efficiencies.",
    buttonText: "Speak to Experts",
  },
  services_corporateservices_entitysetup: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "LAUNCH CONFIDENTLY WITH EXPERT ENTITY SETUP",
    subtitle:
      "Setting up a business shouldn't feel overwhelming. We handle every compliance step, so you launch smoothly and stay future-ready from day one.",
    buttonText: "Start Your Journey",
  },
  services_corporateservices_outsourcedfinanceregulatorycompliance: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "REGULATORY COMPLIANCE THAT THINKS AHEAD",
    subtitle:
      "When financial accuracy meets regulatory discipline, your business stops firefighting and starts performing.",
    buttonText: "Speak to Specialists",
  },
  services_corporateservices_companysecertarial: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "BOARD SUPPORT THAT NEVER MISSES A DEADLINE",
    subtitle:
      "When your statutory books stay perfect, your company stays protected. Our secretarial team ensures every filing, record, and board action is documented, updated.",
    buttonText: "Speak to Experts",
  },
  industries_naturalresourcesandenergy_oilandgas: {
    image: "/assets/images/oil-gas-banner.jpg",
    showBgTitle: false,
    title: `Oil and Gas`,
    subtitle:
      "The oil and gas industry is evolving faster than ever, and we help leaders stay ahead with insight, discipline, and strategic direction.",
    buttonText: "Explore Our Expertise",
  },
  industries_naturalresourcesandenergy_powerandutilities: {
    image: "/assets/images/oil-gas-banner.jpg",
    showBgTitle: false,
    title: `POWER & UTILITIES`,
    subtitle:
      "This sector is navigating rising consumption, digital grids, and regulatory pressure with unprecedented urgency.",
    buttonText: "Explore Our Expertise",
  },
  industries_naturalresourcesandenergy_wastemanagement: {
    image: "/assets/images/oil-gas-banner.jpg",
    showBgTitle: false,
    title: `WASTE MANAGEMENT`,
    subtitle:
      "Modern waste systems need financial clarity, operational efficiency, and long-term sustainability planning.",
    buttonText: "Explore Our Expertise",
  },
  industries_naturalresourcesandenergy_miningandminerals: {
    image: "/assets/images/oil-gas-banner.jpg",
    showBgTitle: false,
    title: `MINING AND MINERALS`,
    subtitle:
      "Today's mining leaders need stronger risk management, advanced digital tools, and sustainable performance—we help you achieve all three.",
    buttonText: "Explore Solutions",
  },
  industries_financialservices_assetmanagement: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `ASSET MANAGEMENT BUILT FOR TOMORROW`,
    subtitle:
      "Helping firms strengthen portfolios, manage risk, and deliver long-term value.",
    buttonText: "Explore Solutions",
  },
  industries_financialservices_banking: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `BANKING SERVICES FOR TOMORROW`,
    subtitle:
      "Empowering banks with strategies that reduce risk and deepen customer trust.",
    buttonText: "Explore Solutions",
  },
  industries_financialservices_financialadvisoryservices: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `FINANCIAL ADVISORY SERVICES`,
    subtitle: "Clear insights, smarter decisions, stronger financial outcomes.",
    buttonText: "Speak to Advisor",
  },
  industries_financialservices_financialservicetax: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `TAX ADVISORY EXCELLENCE`,
    subtitle:
      "Helping businesses navigate complex tax landscapes with clarity, compliance, and confidence.",
    buttonText: "Explore Tax Services",
  },
  industries_financialservices_fintech: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `FINTECH. DIGITAL FINANCE EVOLVED.`,
    subtitle:
      "Enabling agile, compliant, and scalable digital financial models for the next era of financial services.",
    buttonText: "Explore FinTech Solutions",
  },
  industries_financialservices_insurance: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `INSURANCE WITH FINANCIAL CLARITY`,
    subtitle:
      "Guiding insurers with financial discipline and actionable risk intelligence.",
    buttonText: "Learn More",
  },
  industries_healthcare: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `TRANSFORMING HEALTHCARE VALUE`,
    subtitle:
      "Enabling health systems to make better financial, operational, and patient-focused decisions.",
    buttonText: "Explore Healthcare",
  },
  industries_lifescience: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `SCIENCE SHAPING PROGRESS`,
    subtitle:
      "Supporting biotech, pharma, and research teams with financial clarity and operational confidence.",
    buttonText: "Explore More",
  },
  industries_privateequity: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `PRIVATE EQUITY INSIGHTS`,
    subtitle:
      "Helping investors respond to tighter valuations, rising costs, and shifting regulations with strategies grounded in real market performance.",
    buttonText: "Explore Our Expertise",
  },
  industries_professionalservice: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `MODERNIZING PROFESSIONAL SERVICES`,
    subtitle:
      "Helping firms strengthen delivery, improve utilization, and unlock smarter financial and operational decisions.",
    buttonText: "Explore Our Expertise",
  },
  industries_publicsector: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `SMARTER PUBLIC SYSTEMS`,
    subtitle:
      "Helping govt. and public institutions improve efficiency, strengthen financial control, and deliver better citizen outcomes.",
    buttonText: "There's More!",
  },
  industries_realestateconstruction: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `STRONGER REAL ESTATE SYSTEMS`,
    subtitle:
      "Helping developers, contractors, and real estate firms improve financial control and unlock sustainable growth.",
    buttonText: "Learn More",
  },
  industries_technologymediaentertainmenttelecommunications_mediaandentertainment: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `CREATING TOMORROW'S ENTERTAINMENT`,
    subtitle:
      "Helping studios, platforms, and media businesses make sharper decisions across content, audiences, and monetization.",
    buttonText: "Discover M&E",
  },
  industries_technologymediaentertainmenttelecommunications_technology: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `SMARTER DIGITAL FUTURES`,
    subtitle:
      "We aim to help tech businesses innovate faster, scale smarter, and compete in a rapidly changing TMT landscape.",
    buttonText: "Explore Tech",
  },
  industries_technologymediaentertainmenttelecommunications_telecommunication: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `STRONGER TELECOM OUTCOMES`,
    subtitle:
      "Helping telecom operators strengthen performance, optimize investments, and deliver reliable connectivity at scale.",
    buttonText: "Explore Telecom",
  },
};

// ==========================================================
// MASTER BANNER CONFIG — FRENCH
// ==========================================================
const bannerConfigFR = {
  about: {
    image: "/assets/images/about-banner.jpg",
    showBgTitle: true,
    bgTitle: "À PROPOS",
    title: `ÉTABLIR DE NOUVELLES NORMES EN INTELLIGENCE FINANCIÈRE ET CONSEIL`,
    subtitle:
      "Notre équipe combine une expertise financière éprouvée avec une compréhension concrète pour aider les organisations à croître, optimiser et rester résilientes.",
    buttonText: null,
  },
  careers: {
    image: "/assets/images/about-banner.jpg",
    showBgTitle: true,
    bgTitle: "Carrières",
    title: `Rejoignez Notre Équipe d'Experts Financiers`,
    subtitle:
      "Façonnez votre carrière avec une entreprise qui valorise la croissance, l'innovation et l'excellence. Construisez votre avenir avec des professionnels leaders du secteur.",
    buttonText: null,
  },
  blog: {
    image: "/assets/images/about-banner.jpg",
    showBgTitle: true,
    bgTitle: "Blog",
    title: `Perspectives et Articles`,
    subtitle: "Points de vue d'experts sur la comptabilité, la finance et la croissance des entreprises",
    buttonText: null,
  },
  contact: {
    image: "/assets/images/about-banner.jpg",
    showBgTitle: true,
    bgTitle: "Contactez-nous",
    title: `Contactez-nous pour toute question`,
    subtitle: "",
    buttonText: null,
  },
  services_auditandassurance_financialstatementaudit: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `INTÉGRITÉ FINANCIÈRE ASSURÉE AVEC EXPERTISE`,
    subtitle:
      "Les entreprises font face à la pression de conformité et les investisseurs exigent des rapports transparents. Nos audits vérifient chaque chiffre, réduisent les risques et renforcent la confiance.",
    buttonText: "Explorer nos Services d'Audit",
  },
  services_auditandassurance_ifrsadvisoryservice: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `CONSEIL IFRS POUR LA FINANCE MODERNE`,
    subtitle:
      "Réalisez des transitions de reporting fluides avec des experts qui traduisent les normes IFRS complexes en états financiers clairs, conformes et prêts pour la prise de décision.",
    buttonText: "Parler aux Experts",
  },
  services_auditandassurance_internalcontrolframework: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `CONTRÔLES INTERNES QUI RENFORCENT CHAQUE DÉCISION`,
    subtitle:
      "Les contrôles internes échouent silencieusement jusqu'à ce que le risque devienne visible. Nous construisons des cadres qui préviennent les défaillances avant qu'elles ne vous coûtent.",
    buttonText: "Commencer Votre Évaluation",
  },
  services_auditandassurance_otherassuranceservice: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `ASSURANCE QUI VA AU-DELÀ DES CHIFFRES`,
    subtitle:
      "L'assurance n'est pas de la paperasse, c'est un levier. Utilisez des informations vérifiées pour améliorer votre position auprès des investisseurs, régulateurs et partenaires.",
    buttonText: "Explorer nos Services d'Assurance",
  },
  services_advisory_dealadvisory: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `DES DÉCISIONS QUI TRANSFORMENT LES TRANSACTIONS EN SUCCÈS`,
    subtitle:
      "Nous guidons les entreprises à travers les fusions, acquisitions, cessions et transactions de capital avec clarté, prévoyance et intelligence basée sur les données.",
    buttonText: "Parler aux Experts en Transactions",
  },
  services_advisory_restructuring: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `QUAND LES ENTREPRISES ONT BESOIN D'UN NOUVEAU DÉPART`,
    subtitle:
      "Les pressions de trésorerie, les opérations fragmentées et les changements de marché peuvent faire dérailler une entreprise. Nous aidons les organisations à se réaligner, récupérer et revenir plus fortes.",
    buttonText: "En Savoir Plus sur le Conseil",
  },
  services_advisory_duediligence: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `DUE DILIGENCE INTELLIGENTE POUR DES INVESTISSEMENTS PLUS JUDICIEUX`,
    subtitle:
      "Aucun signal manqué. Aucun risque caché. Juste une due diligence transparente qui stimule une croissance confiante.",
    buttonText: "Explorer la Due Diligence",
  },
  services_advisory_forensicservices: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `VOTRE PREMIÈRE DÉFENSE CONTRE LA FRAUDE ET LA MAUVAISE CONDUITE`,
    subtitle:
      "Rapports basés sur des preuves, documentation prête pour les litiges, audits de risque de fraude et analyses forensiques conçues pour l'assurance d'entreprise.",
    buttonText: "Demander un Soutien Forensique",
  },
  services_advisory_riskadvisory: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `VOIR LE RISQUE AVANT QU'IL NE FRAPPE`,
    subtitle:
      "Les marchés changent. Les réglementations se resserrent. Les systèmes échouent. Les risques émergent silencieusement à moins d'être surveillés avec intelligence et traités avec clarté. Quelle est la suite?",
    buttonText: "Construire une Stratégie de Risque!",
  },
  services_advisory_technologyadvisoryservice: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `TECHNOLOGIE QUI RÉDUIT LE BRUIT, GÉNÈRE DE LA VALEUR`,
    subtitle:
      "La transformation numérique ne devrait pas être complexe ou coûteuse. Nous aidons les entreprises à choisir une technologie qui améliore la vitesse, la sécurité et la rentabilité, pas seulement l'infrastructure.",
    buttonText: "Parler au Conseiller",
  },
  services_advisory_valuations: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: `QUAND LE PRIX RENCONTRE LA PREUVE, LES TRANSACTIONS SE RENFORCENT`,
    subtitle:
      "Obtenez une clarté plus précise sur la valeur de l'entreprise grâce à une évaluation analytique soutenue par des références, des prévisions et des preuves.",
    buttonText: "Parler à l'Expert",
  },
  services_taxation_corporatetax: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "CONSEIL FISCAL DE PRÉCISION POUR LES ENTREPRISES INTELLIGENTES",
    subtitle:
      "Les entreprises qui s'associent avec nous réduisent leur exposition fiscale, renforcent leurs rapports et découvrent des opportunités d'économies cachées dans la législation.",
    buttonText: "Parler au Stratège",
  },
  services_taxation_mergerandacquisition: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "STRUCTURER LES TRANSACTIONS, RÉDUIRE LE STRESS FISCAL",
    subtitle:
      "Les F&A réussissent seulement lorsque la base fiscale est sans risque et stratégiquement financière. Nous assurons que chaque transaction est structurée pour des économies et une création de valeur à long terme.",
    buttonText: "Explorer le Conseil en F&A",
  },
  services_taxation_transferpricing: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "NE LAISSEZ PAS LA CONFORMITÉ MANGER VOS PROFITS",
    subtitle:
      "Nous créons des cadres de tarification qui satisfont les autorités tout en protégeant les marges. Un équilibre entre efficacité fiscale et défendabilité réglementaire.",
    buttonText: "Travailler avec des Experts",
  },
  services_taxation_valueaddedtax: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "CONFORMITÉ AUJOURD'HUI, CERTITUDE FISCALE DEMAIN",
    subtitle:
      "La TVA ne consiste pas seulement à déposer des déclarations! Nous aidons les entreprises à rester conformes, réduire l'exposition et rendre les résultats fiscaux prévisibles dans leurs opérations.",
    buttonText: "Parler aux Spécialistes TVA",
  },
  services_taxation_internationaltax: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "INTELLIGENCE FISCALE STRATÉGIQUE AU-DELÀ DES FRONTIÈRES",
    subtitle:
      "Développez-vous mondialement sans trébucher sur les barrières fiscales. Nous vous aidons à naviguer dans les réglementations internationales, optimiser la fiscalité transfrontalière et débloquer des opportunités avec conformité.",
    buttonText: "Obtenir des Conseils d'Experts",
  },
  services_taxation_excisetax: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "CONFORMITÉ QUI PROTÈGE LES PROFITS SANS APPROXIMATION",
    subtitle:
      "Les lois fiscales sur les accises changent rapidement — une mise à jour manquée peut coûter cher à une entreprise. Notre équipe s'assure que vous classez, calculez et respectez avec une précision absolue.",
    buttonText: "Parler au Conseiller",
  },
  services_taxation_taxrestructuring: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "RESTRUCTURATION FISCALE QUI RAPPORTE",
    subtitle:
      "La restructuration fiscale ne consiste pas à réduire les coûts. Nous repensons votre structure fiscale pour que votre entreprise économise plus, fonctionne mieux et s'étende plus fort.",
    buttonText: "Parler aux Experts",
  },
  services_taxation_economicsubstanceregulations: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "RAPPORT ESR CONFIANT SANS COMPLEXITÉ",
    subtitle:
      "Les réglementations sur la substance économique exigent la preuve d'une gestion authentique, d'une prise de décision et d'une présence commerciale. Nous vous aidons à évaluer, documenter et démontrer cela.",
    buttonText: "Assurer la Conformité ESR",
  },
  services_businessserviceoutsourcing_financeandaccounting: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "LA CLARTÉ FINANCIÈRE DEVIENT VOTRE AVANTAGE",
    subtitle:
      "Une finance efficace ne se limite pas à la comptabilité; elle stimule également la stratégie, la stabilité et l'évolutivité. Et la bonne nouvelle est que nous prenons en charge votre cycle de vie comptable.",
    buttonText: "Obtenir un Soutien Financier",
  },
  services_businessserviceoutsourcing_corporateadvisoryservices: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "CLARTÉ AVANT CHAQUE MOUVEMENT COMMERCIAL MAJEUR",
    subtitle:
      "La croissance n'est pas une chance — elle est structurée, informée et stratégiquement naviguée. Nous aidons les organisations à prendre des décisions à haute valeur soutenues par la perspicacité, pas l'intuition.",
    buttonText: "Obtenir un Soutien Consultatif",
  },
  services_businessserviceoutsourcing_expensesclaimmanagement: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "UNE FAÇON PLUS INTELLIGENTE DE SUIVRE, VÉRIFIER ET REMBOURSER",
    subtitle:
      "Obtenez des pistes d'audit transparentes, des cycles de vérification 2× plus rapides, des soumissions alignées sur les politiques et des informations de dépenses en temps réel.",
    buttonText: "Commencer",
  },
  services_businessserviceoutsourcing_payrollhrservices: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "AUTONOMISER LES ÉQUIPES GRÂCE À UNE PAIE PRÉCISE",
    subtitle:
      "Gérer les personnes est complexe, mais vos opérations de paie et RH n'ont pas à l'être. Nos solutions rationalisées, conformes et entièrement gérées garantissent que chaque processus fonctionne avec précision, sécurité et ponctualité.",
    buttonText: "Explorer les Services de Paie",
  },
  services_businessserviceoutsourcing_secondment: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "TALENT AGILE POUR LES ÉQUIPES MODERNES",
    subtitle:
      "Face à des pics de charge de travail ou à des lacunes soudaines en compétences? Nos experts rejoignent votre équipe instantanément, suivent vos processus internes et maintiennent le fonctionnement fluide de l'entreprise.",
    buttonText: "Demander un Soutien de Détachement",
  },
  services_businessserviceoutsourcing_treasuryservice: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "TRÉSORERIE CONÇUE POUR LES RISQUES D'AUJOURD'HUI",
    subtitle:
      "La gestion de la trésorerie ne concerne plus seulement le traitement des paiements — il s'agit de sauvegarder la liquidité, atténuer les risques et permettre la prise de décision.",
    buttonText: "Explorer les Services de Trésorerie",
  },
  services_strategies_marketresearch: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "RECHERCHE QUI RÉDUIT VOS RISQUES DE MARCHÉ",
    subtitle:
      "Gagner des marchés ne concerne pas les suppositions; il s'agit de clarté. Notre recherche transforme le comportement, les changements de demande et les signaux de l'industrie en une direction stratégique en laquelle vous pouvez avoir confiance.",
    buttonText: "Explorer la Recherche de Marché",
  },
  services_strategies_businessconsulting: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "TRANSFORMER LA COMPLEXITÉ COMMERCIALE EN AVANTAGE CONCURRENTIEL",
    subtitle:
      "Les défis commerciaux se situent rarement en silos, et nos solutions non plus. Pestel & Partners fournit un soutien consultatif qui aide les dirigeants à repenser les opérations et débloquer les efficacités.",
    buttonText: "Parler aux Experts",
  },
  services_corporateservices_entitysetup: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "LANCEZ-VOUS EN TOUTE CONFIANCE AVEC UNE CONFIGURATION D'ENTITÉ EXPERTE",
    subtitle:
      "La création d'une entreprise ne devrait pas être accablante. Nous gérons chaque étape de conformité, pour que vous lanciez en douceur et restiez prêt pour l'avenir dès le premier jour.",
    buttonText: "Commencer Votre Voyage",
  },
  services_corporateservices_outsourcedfinanceregulatorycompliance: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "CONFORMITÉ RÉGLEMENTAIRE QUI ANTICIPE",
    subtitle:
      "Quand la précision financière rencontre la discipline réglementaire, votre entreprise cesse de lutter contre les incendies et commence à performer.",
    buttonText: "Parler aux Spécialistes",
  },
  services_corporateservices_companysecertarial: {
    image: "/assets/images/FinancialStatementAuditBanner.jpg",
    showBgTitle: false,
    title: "SOUTIEN AU CONSEIL QUI NE MANQUE JAMAIS UNE ÉCHÉANCE",
    subtitle:
      "Lorsque vos livres statutaires restent parfaits, votre entreprise reste protégée. Notre équipe de secrétariat s'assure que chaque dépôt, enregistrement et action du conseil est documenté, mis à jour.",
    buttonText: "Parler aux Experts",
  },
  industries_naturalresourcesandenergy_oilandgas: {
    image: "/assets/images/oil-gas-banner.jpg",
    showBgTitle: false,
    title: `Pétrole et Gaz`,
    subtitle:
      "L'industrie pétrolière et gazière évolue plus rapidement que jamais, et nous aidons les dirigeants à garder une longueur d'avance avec perspicacité, discipline et orientation stratégique.",
    buttonText: "Explorer Notre Expertise",
  },
  industries_naturalresourcesandenergy_powerandutilities: {
    image: "/assets/images/oil-gas-banner.jpg",
    showBgTitle: false,
    title: `ÉNERGIE ET SERVICES PUBLICS`,
    subtitle:
      "Ce secteur navigue dans une consommation croissante, des réseaux numériques et une pression réglementaire avec une urgence sans précédent.",
    buttonText: "Explorer Notre Expertise",
  },
  industries_naturalresourcesandenergy_wastemanagement: {
    image: "/assets/images/oil-gas-banner.jpg",
    showBgTitle: false,
    title: `GESTION DES DÉCHETS`,
    subtitle:
      "Les systèmes de déchets modernes nécessitent une clarté financière, une efficacité opérationnelle et une planification de durabilité à long terme.",
    buttonText: "Explorer Notre Expertise",
  },
  industries_naturalresourcesandenergy_miningandminerals: {
    image: "/assets/images/oil-gas-banner.jpg",
    showBgTitle: false,
    title: `MINES ET MINÉRAUX`,
    subtitle:
      "Les dirigeants miniers d'aujourd'hui ont besoin d'une gestion des risques plus forte, d'outils numériques avancés et de performances durables—nous vous aidons à réaliser les trois.",
    buttonText: "Explorer les Solutions",
  },
  industries_financialservices_assetmanagement: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `GESTION D'ACTIFS CONSTRUITE POUR DEMAIN`,
    subtitle:
      "Aider les entreprises à renforcer les portefeuilles, gérer les risques et fournir une valeur à long terme.",
    buttonText: "Explorer les Solutions",
  },
  industries_financialservices_banking: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `SERVICES BANCAIRES POUR DEMAIN`,
    subtitle:
      "Autonomiser les banques avec des stratégies qui réduisent les risques et approfondissent la confiance des clients.",
    buttonText: "Explorer les Solutions",
  },
  industries_financialservices_financialadvisoryservices: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `SERVICES DE CONSEIL FINANCIER`,
    subtitle: "Perspectives claires, décisions plus intelligentes, résultats financiers plus solides.",
    buttonText: "Parler au Conseiller",
  },
  industries_financialservices_financialservicetax: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `EXCELLENCE EN CONSEIL FISCAL`,
    subtitle:
      "Aider les entreprises à naviguer dans des paysages fiscaux complexes avec clarté, conformité et confiance.",
    buttonText: "Explorer les Services Fiscaux",
  },
  industries_financialservices_fintech: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `FINTECH. FINANCE NUMÉRIQUE ÉVOLUÉE.`,
    subtitle:
      "Permettre des modèles financiers numériques agiles, conformes et évolutifs pour la prochaine ère des services financiers.",
    buttonText: "Explorer les Solutions FinTech",
  },
  industries_financialservices_insurance: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `ASSURANCE AVEC CLARTÉ FINANCIÈRE`,
    subtitle:
      "Guider les assureurs avec discipline financière et intelligence des risques exploitable.",
    buttonText: "En Savoir Plus",
  },
  industries_healthcare: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `TRANSFORMER LA VALEUR DES SOINS DE SANTÉ`,
    subtitle:
      "Permettre aux systèmes de santé de prendre de meilleures décisions financières, opérationnelles et axées sur les patients.",
    buttonText: "Explorer la Santé",
  },
  industries_lifescience: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `LA SCIENCE FAÇONNE LE PROGRÈS`,
    subtitle:
      "Soutenir les équipes de biotechnologie, pharmaceutique et de recherche avec clarté financière et confiance opérationnelle.",
    buttonText: "En Savoir Plus",
  },
  industries_privateequity: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `PERSPECTIVES SUR LE CAPITAL-INVESTISSEMENT`,
    subtitle:
      "Aider les investisseurs à répondre à des valorisations plus serrées, des coûts croissants et des réglementations changeantes avec des stratégies ancrées dans les performances réelles du marché.",
    buttonText: "Explorer Notre Expertise",
  },
  industries_professionalservice: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `MODERNISER LES SERVICES PROFESSIONNELS`,
    subtitle:
      "Aider les entreprises à renforcer la prestation, améliorer l'utilisation et débloquer des décisions financières et opérationnelles plus intelligentes.",
    buttonText: "Explorer Notre Expertise",
  },
  industries_publicsector: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `SYSTÈMES PUBLICS PLUS INTELLIGENTS`,
    subtitle:
      "Aider les gouvernements et les institutions publiques à améliorer l'efficacité, renforcer le contrôle financier et fournir de meilleurs résultats aux citoyens.",
    buttonText: "Il y a Plus!",
  },
  industries_realestateconstruction: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `SYSTÈMES IMMOBILIERS PLUS SOLIDES`,
    subtitle:
      "Aider les promoteurs, entrepreneurs et entreprises immobilières à améliorer le contrôle financier et débloquer une croissance durable.",
    buttonText: "En Savoir Plus",
  },
  industries_technologymediaentertainmenttelecommunications_mediaandentertainment: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `CRÉER LE DIVERTISSEMENT DE DEMAIN`,
    subtitle:
      "Aider les studios, plateformes et entreprises médiatiques à prendre des décisions plus précises concernant le contenu, les audiences et la monétisation.",
    buttonText: "Découvrir M&E",
  },
  industries_technologymediaentertainmenttelecommunications_technology: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `AVENIRS NUMÉRIQUES PLUS INTELLIGENTS`,
    subtitle:
      "Nous visons à aider les entreprises technologiques à innover plus rapidement, évoluer plus intelligemment et rivaliser dans un paysage TMT en évolution rapide.",
    buttonText: "Explorer la Technologie",
  },
  industries_technologymediaentertainmenttelecommunications_telecommunication: {
    image: "/assets/images/industriesfinancialservicesassetmanagement.jpg",
    showBgTitle: false,
    title: `RÉSULTATS TÉLÉCOMMUNICATIONS PLUS SOLIDES`,
    subtitle:
      "Aider les opérateurs de télécommunications à renforcer les performances, optimiser les investissements et fournir une connectivité fiable à grande échelle.",
    buttonText: "Explorer les Télécommunications",
  },
};

// ==========================================================
// MAIN COMPONENT
// ==========================================================
export default function Banner({ currentLanguage = "en" }) {
  const { pathname } = useLocation();
  const cleanPath = cleanFullPath(pathname);
  const isFrench = currentLanguage === "fr";

  // Select the appropriate config based on language
  const bannerConfig = isFrench ? bannerConfigFR : bannerConfigEN;
  const current = bannerConfig[cleanPath] || bannerConfig["about"];

  // CONDITION FOR WIDTH (Services + Industries = 650px)
  const isServices = pathname.startsWith("/services");
  const isIndustries = pathname.startsWith("/industries");
  const titleWidth = isServices || isIndustries ? "650px" : "750px";

  return (
    <div style={{ backgroundColor: "#051134" }}>
      <div
        className="banner-section"
        style={{
          backgroundImage: `url(${current.image})`,
        }}
      >
        <div className="banner-overlay"></div>

        <div className="banner-content" style={{ marginLeft: "82px" }}>
          {current.showBgTitle && (
            <h1 className="banner-bg-title">{current.bgTitle}</h1>
          )}

          <h2 className="banner-title" style={{ width: titleWidth }}>
            {current.title.split("\n").map((line, i) => (
              <div key={i}>{line}</div>
            ))}
          </h2>
          <p className="banner-subtext">{current.subtitle}</p>
          {current.buttonText && <CustomButton text={current.buttonText} />}
        </div>
      </div>
    </div>
  );
}